import { getCoordinatesFromAddress, getUserPosition, isPositionValid } from '@Components/Utilities/Geolocation';

const sortDistanceWithEnteredLocation = (geocodingUrl, location) => {
    return getCoordinatesFromAddress(location, geocodingUrl)
        .then(position => {
            if (position && isPositionValid(position)) {
                return position;
            }
            throw new Error();
        });
};

// try to get location from geolocator, then cookies, then signed in user info, if these three options fail show an error and force manual input
// called when user presses 'Use My Current Location'
const runSortWithCurrentLocation = (reverseGeocodingUrl, geocodingUrl, location, setUserLocationCookieUrl, getDecryptedCoordinatesFromUserLocationCookieUrl) => {
    // attempt geolocator first, pass false as second optional paramter to getUserPosition for useCookiesFirst, otherwise defaults to true
    return getUserPosition(false, reverseGeocodingUrl, setUserLocationCookieUrl, getDecryptedCoordinatesFromUserLocationCookieUrl)
        .then(position => {
            if (position && isPositionValid(position)) {
                return position;
            } else {
                // geolocator failed so try the cookies now, pass callback and useCookiesFirst defaults to true
                return getUserPosition(true, null, setUserLocationCookieUrl, getDecryptedCoordinatesFromUserLocationCookieUrl)
                    .then(position => {
                        if (position && isPositionValid(position)) {
                            return position;
                        } else {
                            // otherwise last resort is to grab signed in user data stored in hidden fields (if user signed in only)/ otherwise show error and prompt for manual location
                            return getCoordinatesFromAddress(location, geocodingUrl)
                                .then(position => {
                                    if (position && isPositionValid(position)) {
                                        return position;
                                    }
                                    throw new Error('Failed to get user position.');
                                });
                        }
                    });
            }
        });
};

const runSortWithCurrentLocation_CookiesFirst = (reverseGeocodingUrl, geocodingUrl, location, setUserLocationCookieUrl, getDecryptedCoordinatesFromUserLocationCookieUrl) => {
    // attempt cookies first, then geolocator, then user registration:
    return getUserPosition(true, reverseGeocodingUrl, setUserLocationCookieUrl, getDecryptedCoordinatesFromUserLocationCookieUrl)
        .then(position => {
            if (position && isPositionValid(position)) {
                return position;
            } else {
                // otherwise last resort is to grab signed in user data stored in hidden fields (if user signed in only):
                return getCoordinatesFromAddress(location, geocodingUrl)
                    .then(position => {
                        if (position && isPositionValid(position)) {
                            return position;
                        }
                        throw new Error();
                    });
            }
        });
};

export {
    sortDistanceWithEnteredLocation,
    runSortWithCurrentLocation,
    runSortWithCurrentLocation_CookiesFirst
};